import { Box } from "@mui/material";

export default function LoginContainer({ children }: LoginContainerProps) {
  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {children}
    </Box>
  );
}

interface LoginContainerProps {
  children: React.ReactNode;
}
